import { cn } from '../../lib/cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  elevation?: 0 | 1 | 2 | 3 | 4;
}

const paddingClasses: Record<NonNullable<CardProps['padding']>, string> = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-5',
};

const elevationClasses: Record<NonNullable<CardProps['elevation']>, string> = {
  0: '',
  1: 'shadow-elevation-1',
  2: 'shadow-elevation-2',
  3: 'shadow-elevation-3',
  4: 'shadow-elevation-4',
};

export function Card({
  children,
  padding = 'md',
  elevation = 1,
  className,
  ...props
}: CardProps) {
  return (
    <div
      className={cn(
        'rounded-xl bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 overflow-hidden',
        paddingClasses[padding],
        elevationClasses[elevation],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
